export default "__VITE_PUBLIC_ASSET__9dbb2678__"